import { SET_ROOM } from "./action";

const defaultState = {
  roomObj: {},
  wellnessParamsObject: {},
  teamChallenges: {},
  sessionObj: {},
  flippedCards: [],
  gameName: "",
  userClues: [],
  playerCards: [],
  currentUser: {},
  allGames: [],
  gamesData: {},
  socket_connected: false,
  game_code: null,
  sessionLink: null,
  session_id: "",
  appcuesData: [],
  magicLinkObj: {},
  inGameChangeTeamState: false,
  view_activity: {}
};

const setRoomDetails = (state, action) => {
  const roomObj = action.data.data || action.data.room;
  return roomObj;
};

const reconnectRoom = (state, action) => {
  const newroomObj = Object.assign({}, state.roomObj);

  newroomObj.tabletop.connection_id = action.data;
  return newroomObj;
};

const gameReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_ROOM: {
      const roomDetails = setRoomDetails(state, action);
      if (
        roomDetails &&
        roomDetails.game_state &&
        roomDetails.game_state.status === "Preplay"
      ) {
        return {
          ...state,
          roomObj: roomDetails,
          flippedCards: []
        };
      } else {
        let newState = {
          ...state,
          roomObj: roomDetails
        };
        if (action.data.gameTiming) {
          return { ...newState, ...action.data.gameTiming };
        } else return newState;
      }
    }
    case "SET_WELLNESS_PARAMS_OBJECT": {
      return {
        ...state,
        wellnessParamsObject: action.data
      };
    }
    case "SET_SESSION_LINK": {
      return {
        ...state,
        sessionLink: action.data
      };
    }
    case "SET_TEAM_CHALLENGES": {
      return {
        ...state,
        teamChallenges: action.data
      };
    }
    case "SET_SESSION_ID": {
      return {
        ...state,
        session_id: action.data
      };
    }
    case "SET_EMOJI": {
      return {
        ...state,
        emoji: action.data
      };
    }
    case "SET_MAILCHIMP_ID": {
      return {
        ...state,
        mailchimpId: action.data
      };
    }
    case "SET_CURRENT_USER": {
      return {
        ...state,
        currentUser: action.data
      };
    }
    case "GET_GAMES_SUCCESS": {
      return {
        ...state,
        // allGames: action.payload.data.games,
        allGames: action.payload.data.onboarding.step_3.games,
        gamesData: action.payload.data
      };
    }
    case "SET_USER_CLUES": {
      return {
        ...state,
        userClues: action.data
      };
    }
    case "SET_PLAYER_CARDS": {
      return {
        ...state,
        playerCards: action.data
      };
    }
    case "SET_SESSION": {
      return {
        ...state,
        sessionObj: action.data
      };
    }
    case "END_GAME": {
      return {
        ...state,
        roomObj: {},
        flippedCards: [],
        userClues: [],
        playerCards: []
      };
    }
    case "SET_GAME_NAME": {
      return {
        ...state,
        gameName: action.data
      };
    }
    case "SET_FLIPPED_CARD": {
      return {
        ...state,
        flippedCards: action.data
      };
    }
    case "SET_MAGIC_LINK_DATA": {
      return {
        ...state,
        magicLinkObj: action.data
      };
    }
    case "SET_INGAME_CHANGE_TEAM_STATE": {
      return {
        ...state,
        inGameChangeTeamState: action.data
      };
    }
    case "SET_VIEW_ACTIVITY": {
      return {
        ...state,
        view_activity: action.data
      };
    }

    default:
      return state;
  }
};

export default gameReducer;
